export default __webpack_public_path__ + "static/media/bu-leni.4607380f.png";